import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import instance from '../../services/services';
import { PARCEL_COMPANY_LIST_URL, PARCEL_RETURN_URL } from '../../utils/urls';
import PopupLoginError from './LoginError';


function DirectParcelReturnPopup ({ isPopup, setIsPopup, order_seq }){
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);
  const selectRef = useRef();  // ref 추가
  const [parcelCompanyList, setParcelCompanyList] = useState([]);
  const [parcelNumber, setParcelNumber] = useState('');
  // 드롭다운 상태 추가
  const [isParcelOpen, setIsParcelOpen] = useState(false);
  const [selectedParcel, setSelectedParcel] = useState(null);
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);


  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);
  };
  
  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  // 드롭다운 토글 핸들러
  const handleParcelSelectOpen = () => {
    setIsParcelOpen(prev => !prev);
  };

  // 택배사 선택 핸들러
  const handleParcelSelect = (parcel) => {
    setSelectedParcel(parcel);
    setIsParcelOpen(false);
  };

  // 외부 클릭시 드롭다운 닫기
  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsParcelOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // 팝업이 열릴 때만 API 호출
    if (isPopup) {
      const fetchParcelCompanyList = async () => {
        try {
          const response = await instance.post(PARCEL_COMPANY_LIST_URL);
          setParcelCompanyList(response.data.data);
        } catch (error) {
          console.error('택배사 리스트 가져오기 실패', error);
        }
      };
      fetchParcelCompanyList();
    }
  }, [isPopup]);

  const handleParcelReturn = async () => {
    try {
      const response = await instance.post(PARCEL_RETURN_URL, {
        order_seq: order_seq,
        return_company_name: selectedParcel.name,
        return_company_code: selectedParcel.value,
        return_number: parcelNumber,
      });
      if (response.data.code === 200) {
        setIsPopupLoginError({
          message: "택배 반납 직접 발송 완료",
          action: 'reload'
        });
      }
    } catch (error) {
      console.error('택배 반납 직접 발송 실패', error);
      setIsPopupLoginError({
        message: "택배 반납 직접 발송 실패",
        action: 'reload'
      });
    }
  }

  const handleConfirm = () => {
    setIsPopup(false);
    if (isPopupLoginError.action === 'reload') {
      window.location.reload();
    }
  };

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content ${popupActive ? 'active' : ''}`}>
            <div className="popup_container" style={{overflowY:'unset'}}>
              <h4 className='pop_title line'>택배 반납 직접 발송</h4>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>


              <div className='column parcel_return_box'>
                <p className='b3_1'>송장번호</p>
                <div className="default_input none_class">
                  <input
                    type="text"
                    className="readonly w-half"
                    placeholder="송장번호 입력"
                    onChange={(e) => setParcelNumber(e.target.value)}
                  />
                </div>
              </div>

              <div className='column parcel_return_box' style={{paddingBottom:'16px'}}>
                <p className='b3_1'>택배사</p>
                <div 
                  ref={selectRef}
                  className={`default_select border ${isParcelOpen ? 'open' : ''}`}
                > 
                  <button 
                    type="button" 
                    className={`select_btn gray_icon ${selectedParcel ? 'active' : ''}`}
                    onClick={handleParcelSelectOpen}
                  >
                    <span className="ellipsis_clamp point gray">
                      {selectedParcel ? selectedParcel.name : '택배사 선택'}
                    </span>
                  </button>
                  <ul className="select_list">
                      {Object.entries(parcelCompanyList).map(([key, value]) =>
                        <li 
                          className={`select_item ellipsis1 ${selectedParcel?.value === key ? 'active' : ''}`}
                          key={key}
                          onClick={() => handleParcelSelect({value: key, name: value})}
                        >
                          {value}
                        </li>
                      )}
                    </ul>
                  </div>
              </div>

              <div className='pop_btn_wrap'>
                <button 
                  type="button"
                  className="default_btn black pop_con_btn" 
                  onClick={handleParcelReturn}
                >
                  확인
                </button>
              </div>
            </div>
          </div>
          <PopupLoginError 
            isPopup={isPopupLoginError} 
            setIsPopup={setIsPopupLoginError}
            onConfirm={handleConfirm}
          />
        </div>
    );
};

export default DirectParcelReturnPopup ;